import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const formatTimeAgo = (date) => {
  if (!date || typeof date !== 'number' || date <= 0) return 'N/A';
  const now = Date.now();
  const diff = Math.floor((now - date) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  return new Date(date).toLocaleString();
};

const LastUpdated = ({ timestamp }) => {
  const [display, setDisplay] = useState(formatTimeAgo(timestamp));

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplay(formatTimeAgo(timestamp));
    }, 30000);
    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <motion.div
      className="last-updated"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      aria-live="polite"
      style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 4 }}
    >
      Last updated: {display}
    </motion.div>
  );
};

export default LastUpdated; 